export default __webpack_public_path__ + "static/media/cross.6c063e9e.svg";